 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryRemarks from "../components/EntryRemarks";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntryBase from "../components/EntryBase";
import Headline from "../components/Headline";
import TenkaiMdMapCardPopup from "./components/TenkaiMdMapCardPopupFloating";
import TenkaiMdBoardFrame from "./components/TenkaiMdBoardFrame";
import TenkaiMdHinbanDialog from "./components/TenkaiMdHinbanDialog";
import TenkaiMdReportOptionDialog from "./components/TenkaiMdReportOptionDialog";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { isEmpty, DicVal, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, initializedata, isEnabled, FormatDate, isDate, continueSession } from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, entrydata, entrytriggercall, setgridlist, setchangeurl } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

const SHOP_DATE_LIMIT_COLUMNS = ["SSDX_SHOPFROM", "SSDX_SHOPTO"];
const TENKAI_YEAR_COLUMN = "SSD_YEAR";
const TENKAI_TEMPLATE_COLUMN = "M_CODE_CODE";
const TENKAI_BRAND_GROUP_COLUMN = "PDTMD_BRDGP";
const TENKAI_BRAND_COLUMN = "PDT_BRDCODE";
const SHOP_DATE_LIMIT_DAYS = 365;
const SHOP_DATE_LIMIT_MESSAGE = "入力可能範囲は1年以内です";
const SHOP_DATE_ORDER_MESSAGE = "表示期間（TO）は表示期間（FROM）以上で入力してください";
const TenkaiMdButtons = [
    { key: "show", label: "表示" },
    { key: "registered-item", label: "登録済品番追加" },
    { key: "new-item", label: "新規品番追加" },
    { key: "map-card", label: "MAPカード未分類" },
];

const BOARD_AXIS_DEFAULTS = {
    horizontal: { column: "SSDX_SHOPYMDW", label: "展開週" },
    vertical: { column: "PDT_ITMCITEMCD", label: "アイテム" }
};

const NEW_ITEM_POPUP_NAME = "TenkaiMdProductSubWindow";
const PRODUCT_SUBWINDOW_FEATURE = "width=1200,height=800,left=80,top=40,resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no";
const PRODUCT_SUBWINDOW_STARTUP_KEY = "TenkaiMdProductSubWindowStartup";
const REGISTERED_ITEM_SEARCH_DATAID = "FD_SSD:MDADD";
const REGISTERED_ITEM_SEARCH_CHANGE_URL = "common/GetSearchMasterList=tenkaimd/GetRegisteredHinbanSearchList";
const REGISTERED_ITEM_SEARCH_TITLE = "MAPカード検索";
const MAP_CARD_PLACEMENT_CONFIRM_MESSAGE = [
    "品番マスタと未発注の加工指示データに対してボード情報を更新します。",
    "よろしいですか？"
];
const MAP_CARD_MOVE_CONFIRM_MESSAGE = "移動しますか？";
const MAP_CARD_ISSUED_UPDATE_BLOCK_MESSAGE = "発注済みのため更新できません。";
const MAP_CARD_DEFAULT_COLUMNS_PER_ROW = 5;

const BOARD_AXIS_TOKEN_MAP = [
    { column: "SSDX_SHOPYMDW", label: "展開週", tokens: ["SSDX_SHOPYMDW", "PDTMD_SHOPYMDW", "SHOPYMDW", "週", "週次", "展開週", "WEEK"] },
    { column: "SSDX_SHOPYMDM", label: "展開月", tokens: ["SSDX_SHOPYMDM", "PDTMD_SHOPYMDM", "SHOPYMDM", "MONTH", "月", "展開月"] },
    { column: "SSDX_SHOPYMD", label: "店頭展開日", tokens: ["SSDX_SHOPYMD", "PDTMD_SHOPYMD", "SHOPYMD", "店頭展開日", "表示期間", "展開日", "納品日", "DATE"] },
    { column: "PDTMD_BRDGP", label: "ブランドグループ", tokens: ["PDTMD_BRDGP", "BRANDGROUP", "ブランドグループ", "ブランドGP", "ブランドＧＰ"] },
    { column: "PDT_BRDCODE", label: "ブランド", tokens: ["PDT_BRDCODE", "BRANDCODE", "ブランドコード", "ブランド"] },
    { column: "PDT_SEASONCD", label: "シーズン", tokens: ["PDT_SEASONCD", "SEASON", "シーズン"] },
    { column: "PDT_ITMCITEMCD", label: "アイテム", tokens: ["PDT_ITMCITEMCD", "PDT_AITEMCITEMCD", "ITEM", "アイテム"] },
    { column: "PDTMD_CATEGORY", label: "カテゴリ", tokens: ["PDTMD_CATEGORY", "CATEGORY", "カテゴリ", "カテゴリー"] },
    { column: "TNY_TNJNO", label: "展示会No", tokens: ["TNY_TNJNO", "TNJNO", "展示会NO", "展示会番号", "展示会No"] },
    { column: "SSD_SIIRECD", label: "仕入先", tokens: ["SSD_SIIRECD", "仕入先"] },
    { column: "SSD_KAKOUSAKICD", label: "加工先", tokens: ["SSD_KAKOUSAKICD", "加工先"] },
    { column: "SSDX_KIKAKUNO", label: "企画No", tokens: ["SSDX_KIKAKUNO", "KIKAKUNO", "企画NO", "企画番号", "企画No"] }
];

function normalizeTenkaiMdSearchFields(fields) {
    if (!Array.isArray(fields)) return fields;

    return fields.map(field => {
        if (String(field?.columnid || "").toUpperCase() !== TENKAI_BRAND_GROUP_COLUMN) {
            return field;
        }

        return {
            ...field,
            required: false
        };
    });
}

export const TenkaiMd = props => {

    const panelsdef = [];
    const CELLTYPE = CellType();
    const G_id = { BASE: "0", IMAGE: "pic", FILE: "file", NB: "nb" }
    const formid = getformid("Tenkaimd", props.location.search);
    const controller = getcontroller("Tenkaimd", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const user = useSelector(state => state.user);
    const menus = useSelector(state => state.menu.menus);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const searchlistOpen = useSelector(state => state.search.open);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const fnc = useRef();
    const entryFnc = useRef(null);
    if (entryFnc.current === null) {
        entryFnc.current = new Proxy({}, {
            get: function (_target, property) {
                const current = fnc.current;
                if (isEmpty(current)) return undefined;
                if (property === "searchlistopen") {
                    return openTenkaiEntrySearchList;
                }

                const value = current[property];
                return typeof value === "function" ? value.bind(current) : value;
            }
        });
    }
    const masterBaseRef = useRef(null);
    const AGRef = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State

    const formstatus = useSelector(state => state.form.status);
    const modify = useSelector(state => state.form.modify);
    const entrylock = useSelector(state => state.form.entryformlock);
    const changeurl = useSelector(state => state.form.changeurl);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [primarykeys, setprimarykeys] = useState([]);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const [mapCardPopupOpen, setMapCardPopupOpen] = useState(false);
    const [hinbanDialogOpen, setHinbanDialogOpen] = useState(false);
    const [hinbanDialogInitialValues, setHinbanDialogInitialValues] = useState(null);
    const [hinbanDialogMapCardItem, setHinbanDialogMapCardItem] = useState(null);
    const [hinbanDialogEditMode, setHinbanDialogEditMode] = useState(false);
    const [reportOptionDialogOpen, setReportOptionDialogOpen] = useState(false);
    const [reportOutputFormat, setReportOutputFormat] = useState("excel");
    const [reportOutputting, setReportOutputting] = useState(false);
    const [mapBoardVisible, setMapBoardVisible] = useState(false);
    const [mapBoardCards, setMapBoardCards] = useState([]);
    const [unclassifiedMapCards, setUnclassifiedMapCards] = useState([]);
    const [mapBoardTemplate, setMapBoardTemplate] = useState(null);
    const [mapBoardCellWidthOverrides, setMapBoardCellWidthOverrides] = useState({});
    const mapBoardTemplateRef = useRef(null);
    const mapSearchDataRef = useRef([]);
    const deletedMapCardKeysRef = useRef(new Set());
    const deletedMapCardItemsRef = useRef(new Map());
    const dragMapCardRef = useRef({ item: null, source: "", key: "" });
    const addNewSubWindowRef = useRef(null);
    const addNewSubWindowWatcherRef = useRef(null);
    const registeredItemSearchActiveRef = useRef(false);
    const registeredItemSearchChangeUrlBackupRef = useRef([]);
    const registeredItemSearchRoutingActiveRef = useRef(false);
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    //データ
    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  
    const shopDateValidationRef = useRef({
        snapshot: {},
        validationTimers: {}
    });
    const tenkaiYearEnterRef = useRef({
        pendingId: "",
        timer: null
    });
    const displayConditionNameRequestSeqRef = useRef({});

    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
    function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }

    const actionurl = {
        "insert": "tenkaimd/Insert",
         "update": "tenkaimd/Update",
         "delete": "tenkaimd/Delete",
         "saveas": "tenkaimd/SaveAs",
         "storageadd": "tenkaimd/AddStorage",
         "storagerowdel": "tenkaimd/StorageRowdel",
         "upload": "tenkaimd/Upload"
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "print_md_map_excel", icon: "print", label: "MDマップ発行（Excel）", title: "MDマップをExcel形式で出力します" },
        { status: "ENTRY FORM", menuid: "print_md_map_pdf", icon: "picture_as_pdf", label: "MDマップ発行（PDF）", title: "MDマップをPDF形式で出力します" },
    ]

    useEffect(() => {
        masterBaseRef.current?.hideMenucmd([
            { status: "ENTRY FORM", cmd: "登録" },
            { status: "ENTRY FORM", cmd: "再表示" }
        ]);
    }, []);

    function rerender() {
        setUpdata(update ? false : true);
    }

    function closeRegisteredItemSearchState() {
        restoreRegisteredItemSearchChangeUrl();
        registeredItemSearchActiveRef.current = false;
    }

    function isSameChangeUrl(left, right) {
        if (!Array.isArray(left) || !Array.isArray(right)) return false;
        if (left.length !== right.length) return false;

        for (let i = 0; i < left.length; i++) {
            if (left[i] !== right[i]) return false;
        }

        return true;
    }

    function createRegisteredItemSearchChangeUrl(baseChangeUrl) {
        const source = Array.isArray(baseChangeUrl) ? [...baseChangeUrl] : [];
        const filtered = source.filter((value) => {
            if (typeof value !== "string") return true;
            return value.toLowerCase().indexOf("common/getsearchmasterlist=") !== 0;
        });

        filtered.push(REGISTERED_ITEM_SEARCH_CHANGE_URL);
        return filtered;
    }

    function ensureRegisteredItemSearchChangeUrl() {
        if (registeredItemSearchRoutingActiveRef.current) return;

        const nextChangeUrl = createRegisteredItemSearchChangeUrl(changeurl);
        if (isSameChangeUrl(nextChangeUrl, changeurl)) {
            registeredItemSearchChangeUrlBackupRef.current = Array.isArray(changeurl) ? [...changeurl] : [];
            registeredItemSearchRoutingActiveRef.current = true;
            return;
        }

        registeredItemSearchChangeUrlBackupRef.current = Array.isArray(changeurl) ? [...changeurl] : [];
        dispatch(setchangeurl(nextChangeUrl));
        registeredItemSearchRoutingActiveRef.current = true;
    }

    function restoreRegisteredItemSearchChangeUrl() {
        if (!registeredItemSearchRoutingActiveRef.current) return;

        dispatch(setchangeurl(registeredItemSearchChangeUrlBackupRef.current));
        registeredItemSearchRoutingActiveRef.current = false;
    }

    function buildProductSubWindowStartupData(item) {
        return {
            PDT_OPPICD: String(resolveMapCardValue(item, ["PDT_OPPICD", "PDT_OppiCd"]) || "").trim(),
            PDTMD_OPPICD: String(resolveMapCardValue(item, ["PDTMD_OPPICD", "PDT_OPPICD", "PDT_OppiCd"]) || "").trim(),
            SSD_NO: String(resolveMapCardValue(item, ["SSD_NO"]) || "").trim()
        };
    }

    function buildHinbanMasterStartupData(item, launchOppiCd, brandHinban) {
        const rowData = cloneMapCardItem(item) || {};
        return {
            status: "ENTRY",
            code: launchOppiCd,
            acceptno: launchOppiCd,
            data: rowData,
            entryrowdata: rowData,
            ...buildProductSubWindowStartupData(item),
            PDT_OPPICD: launchOppiCd,
            PDT_SYOHINCD: brandHinban
        };
    }

    function storeProductSubWindowStartupData(sub, startupData) {
        if (isEmpty(sub)) return;

        try {
            sub.sessionStorage.setItem(PRODUCT_SUBWINDOW_STARTUP_KEY, JSON.stringify(startupData || {}));
        } catch {
        }
    }

    function buildHinbanDialogInitialValues(item) {
        const header = entrydataRef.current || {};
        const selected = isEmpty(item) ? {} : item;

        return {
            brandGroup: String(
                resolveMapCardValue(selected, ["PDTMD_BRDGP", "BRANDGROUP"]) ||
                DicVal(header, "PDTMD_BRDGP", "") ||
                ""
            ).trim(),
            brand: String(
                resolveMapCardValue(selected, ["PDT_BRDCODE", "BRAND"]) ||
                DicVal(header, "PDT_BRDCODE", "") ||
                ""
            ).trim(),
            year: String(
                resolveMapCardValue(selected, ["PDT_YEAR", "SSD_YEAR"]) ||
                DicVal(header, "SSD_YEAR", "") ||
                ""
            ).trim(),
            season: String(
                resolveMapCardValue(selected, ["PDT_SEASONCD", "SSD_SEASONCD"]) ||
                DicVal(header, "PDT_SEASONCD", "") ||
                DicVal(header, "SSD_SEASONCD", "") ||
                ""
            ).trim(),
            item: String(
                resolveMapCardValue(selected, ["PDT_ITMITEMCD", "PDT_ITMCITEMCD", "PDT_AITEMCITEMCD"]) ||
                DicVal(header, "PDT_ITMCITEMCD", "") ||
                DicVal(header, "PDT_AITEMCITEMCD", "") ||
                ""
            ).trim(),
            category: String(
                resolveMapCardValue(selected, ["PDTMD_CATEGORY"]) ||
                DicVal(header, "PDTMD_CATEGORY", "") ||
                ""
            ).trim(),
            shopDate: String(
                resolveMapCardValue(selected, ["PDTMD_SHOPYMD", "SSDX_SHOPYMD"]) ||
                DicVal(header, "SSDX_SHOPYMD", "") ||
                DicVal(header, "PDTMD_SHOPYMD", "") ||
                ""
            ).trim(),
            rolloutMonth: String(
                resolveMapCardValue(selected, ["PDTMD_SHOPYMDM", "SSDX_SHOPYMDM"]) ||
                DicVal(header, "SSDX_SHOPYMDM", "") ||
                DicVal(header, "PDTMD_SHOPYMDM", "") ||
                ""
            ).trim(),
            rolloutWeek: String(
                resolveMapCardValue(selected, ["PDTMD_SHOPYMDW", "SSDX_SHOPYMDW"]) ||
                DicVal(header, "SSDX_SHOPYMDW", "") ||
                DicVal(header, "PDTMD_SHOPYMDW", "") ||
                ""
            ).trim()
        };
    }

    function openHinbanDialog(item, options = {}) {
        const nextEditMode = options.editMode === true;
        setHinbanDialogInitialValues(buildHinbanDialogInitialValues(item));
        setHinbanDialogMapCardItem(isEmpty(item) ? null : item);
        setHinbanDialogEditMode(nextEditMode);
        setHinbanDialogOpen(true);
    }

    function openNewHinbanDialog() {
        openHinbanDialog(null, { editMode: false });
    }

    function openEditHinbanDialog(item) {
        if (isEmpty(item) || isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") return;
        if (!ensureMapCardsUpdatable(item)) return;

        const pdtOppiCd = String(resolveMapCardValue(item, ["PDT_OPPICD", "PDTMD_OPPICD", "SSD_OPPICD"]) || "").trim();
        const ssdNo = String(resolveMapCardValue(item, ["SSD_NO", "SSDM_NO", "SSDX_NO"]) || "").trim();
        if (isEmpty(pdtOppiCd)) {
            fnc.current.warnmsg("編集対象の品番内部コードを取得できませんでした。");
            return;
        }

        fnc.current.wait(true);
        fnc.current.postaxios("tenkaimd/GetHinbanEditData", { pdtOppiCd, ssdNo }, {
            onSuccess: function (data) {
                fnc.current.wait(false);
                if (data.status === false) {
                    fnc.current.warnmsg(data.errDescription || "品番編集データの取得に失敗しました。");
                    return;
                }

                const editItem = { ...item };
                Object.entries(data.data || {}).forEach(([key, value]) => {
                    editItem[key] = value;
                });
                editItem.TENKAIMD_EDIT_DETAILS = Array.isArray(data.datas) ? data.datas : [];
                openHinbanDialog(editItem, { editMode: true });
            },
            onError: function (data) {
                fnc.current.wait(false);
                fnc.current.warnmsg(data?.errDescription || "品番編集データの取得に失敗しました。");
            },
            errmsg: "品番編集データの取得に失敗しました。"
        });
    }

    function closeHinbanDialog() {
        if (!isEmpty(fnc.current) && typeof fnc.current.wait === "function") {
            fnc.current.wait(false);
        }
        setHinbanDialogOpen(false);
        setHinbanDialogMapCardItem(null);
        setHinbanDialogEditMode(false);
    }

    function handleHinbanRegisterSuccess(data, options = {}) {
        const wasEditMode = hinbanDialogEditMode;
        const registeredMapCardItem = hinbanDialogMapCardItem;
        setHinbanDialogOpen(false);
        setHinbanDialogMapCardItem(null);
        setHinbanDialogEditMode(false);

        if (options.skipMapCardAllocation === true) {
            return;
        }

        const pdtOppiCd = String(
            data?.returnData?.PDT_OPPICD
            || data?.returnData?.PDTMD_OPPICD
            || data?.results
            || resolveMapCardValue(registeredMapCardItem, ["PDT_OPPICD", "PDTMD_OPPICD", "SSD_OPPICD"])
            || ""
        ).trim();
        const ssdNo = String(
            data?.returnData?.SSD_NO
            || data?.returnData?.SSDM_NO
            || data?.returnData?.SSDX_NO
            || (!wasEditMode ? data?.request : "")
            || resolveMapCardValue(registeredMapCardItem, ["SSD_NO", "SSDM_NO", "SSDX_NO"])
            || ""
        ).trim();
        if (isEmpty(pdtOppiCd) || isEmpty(ssdNo)) {
            getMapData();
            return;
        }

        const registerProduct = options?.registerData?.product || null;
        const currentPlacement = buildMapCardPlacementTarget(registeredMapCardItem, boardAxes);
        const isUnclassifiedPopupItem =
            !isEmpty(registeredMapCardItem)
            && isEmpty(currentPlacement.horizontalValue)
            && isEmpty(currentPlacement.verticalValue);

        if (isUnclassifiedPopupItem && !isEmpty(registerProduct)) {
            const mergedMapCardItem = mergeRegisteredProductValuesIntoMapCardItem(
                registeredMapCardItem,
                options.registerData
            );
            const placement = buildMapCardPlacementTarget(mergedMapCardItem, boardAxes);
            const shopDateValue = String(
                mergedMapCardItem?.PDTMD_SHOPYMD
                || mergedMapCardItem?.SSDX_SHOPYMD
                || registerProduct.shopDate
                || ""
            ).trim();

            if (!isEmpty(placement.horizontalValue) && !isEmpty(placement.verticalValue)) {
                executeMapCardPlacementDrop(
                    {
                        ...placement,
                        shopDateValue: shopDateValue
                    },
                    mergedMapCardItem,
                    getMapCardKey(registeredMapCardItem),
                    "popup",
                    {
                        afterSuccess: () => getCreatedMapCards(pdtOppiCd, ssdNo),
                        afterError: () => getCreatedMapCards(pdtOppiCd, ssdNo)
                    }
                );
                return;
            }
        }

        getCreatedMapCards(pdtOppiCd, ssdNo);
    }

    function openProductSubWindow(item) {
        const sub = openPlaceholderPopup(NEW_ITEM_POPUP_NAME, PRODUCT_SUBWINDOW_FEATURE);
        if (!sub) {
            return null;
        }

        storeProductSubWindowStartupData(sub, buildProductSubWindowStartupData(item));
        startAddNewSubWindowWatcher();
        try {
            sub.document.title = "品番サブ";
        } catch {
        }
        try {
            if (typeof sub.focus === "function") {
                sub.focus();
            }
        } catch {
        }

        return sub;
    }

    function openRegisteredItemSearchList() {
        if (isEmpty(fnc.current) || typeof fnc.current.searchlistopen !== "function") {
            return;
        }
        if (registeredItemSearchActiveRef.current) {
            return;
        }

        ensureRegisteredItemSearchChangeUrl();
        registeredItemSearchActiveRef.current = true;

        fnc.current.searchlistopen({
            label: REGISTERED_ITEM_SEARCH_TITLE,
            multiple: true,
            rowmode: false,
            data: {
                dataid: REGISTERED_ITEM_SEARCH_DATAID,
                columnid: "__tenkaimd_registered_item__",
                columnnm: REGISTERED_ITEM_SEARCH_TITLE,
                datatype: CELLTYPE.TEXT
            },
            rowdata: entrydataRef.current || {},
            doApply: async function () {
                const eventData = arguments.length > 0 ? arguments[0] : null;
                const selectedItems = normalizeRegisteredItemSearchSelection(eventData);
                if (selectedItems.length > 0) {
                    const applied = appendRegisteredItemsToUnclassifiedDisplay(selectedItems);
                    if (!applied) {
                        return;
                    }
                    setMapCardPopupOpen(true);
                }
                if (fnc.current && fnc.current.searchlistclose) {
                    fnc.current.searchlistclose();
                }
                closeRegisteredItemSearchState();
            }
        });
    }

    function normalizeRegisteredItemSearchSelection(eventData) {
        const sourceItems = Array.isArray(eventData?.items) ? eventData.items : [];
        const result = [];

        for (let i = 0; i < sourceItems.length; i++) {
            const item = sourceItems[i];
            const row = isEmpty(item) ? null : (item.data || item);
            const normalized = normalizeRegisteredItemSearchRow(row);
            if (!isEmpty(normalized)) {
                result.push(normalized);
            }
        }

        return result;
    }

    function normalizeRegisteredItemSearchRow(row) {
        if (isEmpty(row)) return null;

        const brandHinban = resolveMapCardValue(row, ["BRAND_HINBAN", "PDT_SYOHINCD", "PDT_HINBAN", "code"]);
        if (isEmpty(brandHinban)) return null;

        const tenkaiDate = resolveMapCardValue(row, ["PDTMD_SHOPYMD", "SSDX_SHOPYMD", "TENKAI_DATE"]);
        const tenkaiMonth = resolveMapCardValue(row, ["PDTMD_SHOPYMDM", "SSDX_SHOPYMDM", "TENKAI_MONTH"]);
        const tenkaiWeek = resolveMapCardValue(row, ["PDTMD_SHOPYMDW", "SSDX_SHOPYMDW", "TENKAI_WEEK"]);
        const brandCode = resolveMapCardValue(row, ["PDT_BRDCODE"]);
        const brandName = resolveMapCardValue(row, ["BRAND_NAME", "PDT_BRDCODE_nm", "PDT_BRDCODE_NM"]);
        const category = resolveMapCardValue(row, ["CATEGORY", "PDTMD_CATEGORY"]);
        const itemCode = resolveMapCardValue(row, ["PDT_ITMCITEMCD"]);
        const itemName = resolveMapCardValue(row, ["ITEM_NAME", "PDT_ITMCITEMCD_nm", "PDT_ITMCITEMCD_NM"]);
        const kikakuNo = resolveMapCardValue(row, ["PDTMD_KIKAKUNO", "SSDX_KIKAKUNO", "KIKAKU_NO"]);
        const siire = resolveMapCardValue(row, ["SIIRESAKI", "SSD_SIIRECD"]);
        const kakou = resolveMapCardValue(row, ["KAKOUSAKI", "SSD_KAKOUSAKICD", "SSD_KAKOUSAKISUBCD"]);
        const psHinban = resolveMapCardValue(row, ["SSD_OPPICD", "PDT_OPPICD", "PS_HINBAN"]);
        const ssdNo = resolveMapCardValue(row, ["SSD_NO"]);
        const rowId = resolveMapCardValue(row, ["rowid"]);

        const normalized = {
            ...row,
            rowid: rowId,
            code: brandHinban,
            name: resolveMapCardValue(row, ["PDT_HINMEINM", "name", "display"]) || brandHinban,
            display: resolveMapCardValue(row, ["display"]) || brandHinban,
            BRAND_HINBAN: brandHinban,
            PDT_SYOHINCD: brandHinban,
            PDT_HINBAN: brandHinban,
            TENKAI_DATE: tenkaiDate,
            PDTMD_SHOPYMD: tenkaiDate,
            SSDX_SHOPYMD: tenkaiDate,
            TENKAI_MONTH: tenkaiMonth,
            PDTMD_SHOPYMDM: tenkaiMonth,
            SSDX_SHOPYMDM: tenkaiMonth,
            TENKAI_WEEK: tenkaiWeek,
            PDTMD_SHOPYMDW: tenkaiWeek,
            SSDX_SHOPYMDW: tenkaiWeek,
            BRAND_NAME: brandName || brandCode,
            PDT_BRDCODE: brandCode,
            CATEGORY: category,
            PDTMD_CATEGORY: category,
            ITEM_NAME: itemName || itemCode,
            PDT_ITMCITEMCD: itemCode,
            KIKAKU_NO: kikakuNo,
            PDTMD_KIKAKUNO: kikakuNo,
            SSDX_KIKAKUNO: kikakuNo,
            SIIRESAKI: siire,
            SSD_SIIRECD: siire,
            KAKOUSAKI: kakou,
            SSD_KAKOUSAKICD: kakou,
            PS_HINBAN: psHinban,
            PDT_OPPICD: psHinban,
            SSD_OPPICD: psHinban,
            SSD_NO: ssdNo || brandHinban
        };

        return normalized;
    }

    function syncRegisteredItemSearchActionButton() {
        if (!registeredItemSearchActiveRef.current || typeof document === "undefined") {
            return false;
        }

        const drawerRoots = Array.from(document.querySelectorAll(".MuiDrawer-root"));
        const targetRoot = drawerRoots.find((root) => {
            return String(root.textContent || "").indexOf(REGISTERED_ITEM_SEARCH_TITLE) !== -1;
        });
        if (isEmpty(targetRoot)) {
            return false;
        }

        const buttons = Array.from(targetRoot.querySelectorAll("button"));
        const targetButton = buttons.find((button) => {
            const text = String(button.textContent || "").replace(/\s+/g, "").trim();
            return text === "適用" || text === "MAP割当";
        });
        if (isEmpty(targetButton)) {
            return false;
        }

        if (String(targetButton.textContent || "").replace(/\s+/g, "").trim() !== "MAP割当") {
            targetButton.textContent = "MAP割当";
        }
        targetButton.title = "MAP割当";
        targetButton.setAttribute("aria-label", "MAP割当");
        return true;
    }

    function isShopDateLimitColumn(id) {
        return SHOP_DATE_LIMIT_COLUMNS.includes(String(id || "").toUpperCase());
    }

    function normalizeShopDateValue(value) {
        if (isEmpty(value)) return "";
        const text = String(value).trim().replace(/-/g, "/");
        if (!isDate(text)) return null;
        return FormatDate(text);
    }

    function getShopDateUtcTime(value) {
        const normalized = normalizeShopDateValue(value);
        if (normalized === "" || normalized === null) return false;
        const parts = normalized.split("/");
        const target = Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        return Number.isNaN(target) ? false : target;
    }

    function syncShopDateValidationState(data = entrydataRef.current) {
        const timers = shopDateValidationRef.current.validationTimers || {};
        for (let key in timers) {
            clearTimeout(timers[key]);
        }
        const snapshot = {};
        for (let i = 0; i < SHOP_DATE_LIMIT_COLUMNS.length; i++) {
            const id = SHOP_DATE_LIMIT_COLUMNS[i];
            const raw = isEmpty(data) ? "" : data[id];
            const normalized = normalizeShopDateValue(raw);
            if (normalized === null) {
                snapshot[id] = isEmpty(raw) ? "" : String(raw);
            } else {
                snapshot[id] = normalized;
            }
        }
        shopDateValidationRef.current = {
            snapshot: snapshot,
            validationTimers: {}
        };
    }

    function restoreShopDateValue(id, restoreValue) {
        const state = shopDateValidationRef.current;
        const nextValue = restoreValue !== undefined
            ? restoreValue
            : (id in state.snapshot ? state.snapshot[id] : "");
        if (isEmpty(entrydataRef.current)) entrydataRef.current = {};
        entrydataRef.current = {
            ...entrydataRef.current,
            [id]: nextValue
        };
        dispatch(entrydata({ ...entrydataRef.current }));
        if (!isEmpty(fnc.current)) fnc.current.entryrerender();
    }

    function isTenkaiYearColumn(id) {
        return String(id || "").trim().toUpperCase() === TENKAI_YEAR_COLUMN;
    }

    function normalizeTenkaiYearText(value) {
        if (value instanceof Date && !Number.isNaN(value.getTime())) {
            return String(value.getFullYear());
        }
        if (isEmpty(value)) return "";
        const text = String(value).trim().replace(/-/g, "/");
        if (/^\d{4}$/.test(text)) return text;
        const yearMatch = text.match(/^(\d{4})(?:[\/\s].*)?$/);
        if (yearMatch !== null) return yearMatch[1];
        if (!isDate(text)) return null;
        const formatted = FormatDate(text);
        if (isEmpty(formatted)) return null;
        return formatted.split("/")[0];
    }

    function normalizeYearPickerValue(id, value) {
        if (!isTenkaiYearColumn(id)) return value;
        const normalized = normalizeTenkaiYearText(value);
        if (normalized === null || normalized === value) return value;
        if (isEmpty(entrydataRef.current)) entrydataRef.current = {};
        entrydataRef.current = {
            ...entrydataRef.current,
            [id]: normalized
        };
        dispatch(entrydata({ ...entrydataRef.current }));
        if (!isEmpty(fnc.current)) fnc.current.entryrerender();
        return normalized;
    }

    function isTenkaiDisplayNameColumn(id) {
        return !isEmpty(getTenkaiDisplayConditionColumnFromId(id));
    }

    function getTenkaiDisplayConditionColumnFromId(id) {
        const normalizedId = String(id || "").trim().toUpperCase();
        if (normalizedId === TENKAI_BRAND_GROUP_COLUMN) return TENKAI_BRAND_GROUP_COLUMN;
        if (normalizedId === TENKAI_BRAND_COLUMN) return TENKAI_BRAND_COLUMN;
        return "";
    }

    function normalizeTenkaiDisplayCode(value) {
        if (value === null || value === undefined) return "";
        const text = String(value).trim();
        const colonIndex = text.indexOf(":");
        if (colonIndex > 0) {
            return text.substring(0, colonIndex).trim();
        }
        return text;
    }

    function setTenkaiDisplayConditionName(columnid, code, name) {
        if (isEmpty(entrydataRef.current)) entrydataRef.current = {};

        entrydataRef.current = {
            ...entrydataRef.current,
            [columnid]: code,
            [columnid + "_nm"]: name
        };
        dispatch(entrydata({ ...entrydataRef.current }));
        if (!isEmpty(fnc.current)) fnc.current.entryrerender();
    }

    function getTenkaiSearchRowValue(row, columnid) {
        if (isEmpty(row)) return "";
        if (row[columnid] !== undefined && row[columnid] !== null) {
            return String(row[columnid]).trim();
        }

        const key = Object.keys(row).find(item => String(item).toUpperCase() === columnid);
        return isEmpty(key) || row[key] === undefined || row[key] === null
            ? ""
            : String(row[key]).trim();
    }

    function openTenkaiEntrySearchList(payload) {
        if (isEmpty(fnc.current) || typeof fnc.current.searchlistopen !== "function") return;

        const columnid = String(payload?.data?.columnid || "").trim().toUpperCase();
        if (columnid !== TENKAI_BRAND_COLUMN || typeof payload?.doApply !== "function") {
            fnc.current.searchlistopen(payload);
            return;
        }

        const originalApply = payload.doApply;
        fnc.current.searchlistopen({
            ...payload,
            doApply: function (eventData) {
                const selectedItem = Array.isArray(eventData?.items) ? eventData.items[0] : null;
                const selectedRow = selectedItem?.data || selectedItem;
                const brandCode = getTenkaiSearchRowValue(selectedRow, "IBTB_BRDCD");
                if (isEmpty(brandCode)) {
                    originalApply(eventData);
                    return;
                }

                if (typeof fnc.current.setMaster === "function") {
                    fnc.current.setMaster({
                        ...selectedRow,
                        dataid: payload.data.dataid,
                        code: brandCode
                    });
                }
                originalApply({ ...eventData, value: brandCode });
            }
        });
    }

    function syncTenkaiDisplayConditionName(id, value) {
        const columnid = getTenkaiDisplayConditionColumnFromId(id);
        if (isEmpty(columnid)) return;
        const code = normalizeTenkaiDisplayCode(value);

        if (isEmpty(code)) {
            setTenkaiDisplayConditionName(columnid, "", "");
            return;
        }

        if (isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") {
            return;
        }

        const requestSeq = (displayConditionNameRequestSeqRef.current[columnid] || 0) + 1;
        displayConditionNameRequestSeqRef.current[columnid] = requestSeq;

        const param = {
            brandGroupCode: columnid === TENKAI_BRAND_GROUP_COLUMN ? code : "",
            brandCode: columnid === TENKAI_BRAND_COLUMN ? code : ""
        };

        fnc.current.postaxios("tenkaimd/GetDisplayConditionNames", param,
            {
                onSuccess: function (data) {
                    if (displayConditionNameRequestSeqRef.current[columnid] !== requestSeq) return;
                    if (isEmpty(data) || data.status === false) return;

                    const currentCode = normalizeTenkaiDisplayCode(DicVal(entrydataRef.current, columnid, ""));
                    if (currentCode !== code) return;

                    const returnData = data.returnData || {};
                    const name = DicVal(returnData, columnid + "_nm", "");
                    if (!isEmpty(name)) {
                        setTenkaiDisplayConditionName(columnid, code, name);
                    }
                }
            },
            true
        );
    }

    function syncTenkaiDisplayConditionNames(sourceData = entrydataRef.current) {
        if (isEmpty(sourceData) || isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") {
            return;
        }

        const brandGroupCode = normalizeTenkaiDisplayCode(DicVal(sourceData, TENKAI_BRAND_GROUP_COLUMN, ""));
        const brandCode = normalizeTenkaiDisplayCode(DicVal(sourceData, TENKAI_BRAND_COLUMN, ""));
        const needsBrandGroupName = !isEmpty(brandGroupCode);
        const needsBrandName = !isEmpty(brandCode);

        if (!needsBrandGroupName && !needsBrandName) {
            return;
        }

        const requestSeq = (displayConditionNameRequestSeqRef.current.__bulk || 0) + 1;
        displayConditionNameRequestSeqRef.current.__bulk = requestSeq;
        if (needsBrandGroupName) {
            displayConditionNameRequestSeqRef.current[TENKAI_BRAND_GROUP_COLUMN] = requestSeq;
        }
        if (needsBrandName) {
            displayConditionNameRequestSeqRef.current[TENKAI_BRAND_COLUMN] = requestSeq;
        }

        fnc.current.postaxios("tenkaimd/GetDisplayConditionNames",
            {
                brandGroupCode: needsBrandGroupName ? brandGroupCode : "",
                brandCode: needsBrandName ? brandCode : ""
            },
            {
                onSuccess: function (data) {
                    if (displayConditionNameRequestSeqRef.current.__bulk !== requestSeq) return;
                    if (isEmpty(data) || data.status === false) return;

                    const returnData = data.returnData || {};
                    const nextData = { ...(entrydataRef.current || {}) };
                    let changed = false;

                if (needsBrandGroupName
                    && normalizeTenkaiDisplayCode(DicVal(nextData, TENKAI_BRAND_GROUP_COLUMN, "")) === brandGroupCode) {
                    const brandGroupName = DicVal(returnData, TENKAI_BRAND_GROUP_COLUMN + "_nm", "");
                    if (DicVal(nextData, TENKAI_BRAND_GROUP_COLUMN + "_nm", "") !== brandGroupName) {
                        nextData[TENKAI_BRAND_GROUP_COLUMN + "_nm"] = brandGroupName;
                        changed = true;
                    }
                }

                if (needsBrandName
                    && normalizeTenkaiDisplayCode(DicVal(nextData, TENKAI_BRAND_COLUMN, "")) === brandCode) {
                    const brandName = DicVal(returnData, TENKAI_BRAND_COLUMN + "_nm", "");
                    if (DicVal(nextData, TENKAI_BRAND_COLUMN + "_nm", "") !== brandName) {
                        nextData[TENKAI_BRAND_COLUMN + "_nm"] = brandName;
                        changed = true;
                    }
                    }

                    if (!changed) return;

                    entrydataRef.current = nextData;
                    dispatch(entrydata({ ...nextData }));
                    if (!isEmpty(fnc.current)) fnc.current.entryrerender();
                }
            },
            true
        );
    }

    function clearTenkaiYearEnterTimer() {
        const state = tenkaiYearEnterRef.current;
        if (!isEmpty(state.timer)) {
            clearTimeout(state.timer);
            state.timer = null;
        }
    }

    function commitTenkaiYearEnterValidation() {
        const state = tenkaiYearEnterRef.current;
        const id = state.pendingId;
        state.pendingId = "";
        if (isEmpty(id)) return;

        const currentRawValue = DicVal(entrydataRef.current, id, "");
        const normalized = normalizeTenkaiYearText(currentRawValue);
        if (normalized === null) return;

        const currentValue = isEmpty(currentRawValue) ? "" : String(currentRawValue);
        if (normalized === currentValue) return;

        if (isEmpty(entrydataRef.current)) entrydataRef.current = {};
        entrydataRef.current = {
            ...entrydataRef.current,
            [id]: normalized
        };
        dispatch(entrydata({ ...entrydataRef.current }));
        if (!isEmpty(fnc.current)) fnc.current.entryrerender();

        if (!isEmpty(columninfo)) {
            const col = columninfo.find(e => e.columnid === id);
            if (!isEmpty(col) && col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }

    function scheduleTenkaiYearEnterValidation(id) {
        const state = tenkaiYearEnterRef.current;
        clearTenkaiYearEnterTimer();
        state.pendingId = id;
        state.timer = setTimeout(() => {
            state.timer = null;
            commitTenkaiYearEnterValidation();
        }, 0);
    }

    function isTenkaiYearEnterPending(id) {
        return tenkaiYearEnterRef.current.pendingId === id;
    }

    function showShopDateRangeWarning(id, message) {
        fnc.current.showwarndescription("", [{ rowid: "0", col: id, message: message }]);
    }

    function scheduleShopDateValidation(id) {
        const state = shopDateValidationRef.current;
        const timers = state.validationTimers || {};
        if (timers[id]) {
            clearTimeout(timers[id]);
        }
        timers[id] = setTimeout(() => {
            delete state.validationTimers[id];
            validateShopDateRange(id);
        }, 0);
    }

    function validateShopDateRange(id) {
        const state = shopDateValidationRef.current;
        const previousValue = id in state.snapshot ? state.snapshot[id] : "";
        const currentRawValue = DicVal(entrydataRef.current, id, "");
        const currentValue = normalizeShopDateValue(currentRawValue);
        if (currentValue === null) {
            return true;
        }

        const fromValue = normalizeShopDateValue(DicVal(entrydataRef.current, "SSDX_SHOPFROM", ""));
        const toValue = normalizeShopDateValue(DicVal(entrydataRef.current, "SSDX_SHOPTO", ""));
        if (fromValue === null || toValue === null || fromValue === "" || toValue === "") {
            if (fromValue !== null) state.snapshot.SSDX_SHOPFROM = fromValue;
            if (toValue !== null) state.snapshot.SSDX_SHOPTO = toValue;
            if (!isEmpty(fnc.current)) fnc.current.closewarnning();
            return true;
        }

        const toDate = getShopDateUtcTime(toValue);
        const fromTime = getShopDateUtcTime(fromValue);
        if (fromTime === false || toDate === false) {
            if (!isEmpty(fnc.current)) fnc.current.closewarnning();
            return true;
        }
        if (toDate < fromTime) {
            const restoreValue = id in state.snapshot ? state.snapshot[id] : "";
            showShopDateRangeWarning(id, SHOP_DATE_ORDER_MESSAGE);
            restoreShopDateValue(id, restoreValue);
            return false;
        }
        const diffDays = (toDate - fromTime) / (24 * 60 * 60 * 1000);
        if (diffDays > SHOP_DATE_LIMIT_DAYS) {
            const restoreValue = id in state.snapshot ? state.snapshot[id] : "";
            showShopDateRangeWarning(id, SHOP_DATE_LIMIT_MESSAGE);
            restoreShopDateValue(id, restoreValue);
            return false;
        }

        state.snapshot.SSDX_SHOPFROM = fromValue;
        state.snapshot.SSDX_SHOPTO = toValue;
        if (!isEmpty(fnc.current)) fnc.current.closewarnning();
        return true;
    }

    function resolveMapCardValue(item, keys) {
        if (isEmpty(item) || isEmpty(keys)) return "";

        const normalizedKeys = keys
            .map(key => String(key || "").trim().toUpperCase())
            .filter(key => !isEmpty(key));

        if (normalizedKeys.length > 0) {
            const itemKeys = Object.keys(item);
            for (let i = 0; i < itemKeys.length; i++) {
                const currentKey = String(itemKeys[i] || "").trim().toUpperCase();
                if (isEmpty(currentKey)) continue;
                if (normalizedKeys.includes(currentKey) && !isEmpty(item[itemKeys[i]])) {
                    return item[itemKeys[i]];
                }
            }
        }

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (Object.prototype.hasOwnProperty.call(item, key) && !isEmpty(item[key])) {
                return item[key];
            }
        }

        return "";
    }

    function cloneMapCardItem(item) {
        if (isEmpty(item)) return null;
        return { ...item };
    }

    function isIssuedMapCard(item) {
        return !isEmpty(resolveMapCardValue(item, ["SSD_SEIHINHACHUDENNO", "SSD_SeihinHachuDenno"]));
    }

    function showIssuedMapCardUpdateBlockedMessage() {
        if (!isEmpty(fnc.current) && typeof fnc.current.warnmsg === "function") {
            fnc.current.warnmsg(MAP_CARD_ISSUED_UPDATE_BLOCK_MESSAGE);
        }
    }

    function ensureMapCardsUpdatable(items) {
        const sourceItems = Array.isArray(items) ? items : [items];
        const hasIssued = sourceItems.some(item => !isEmpty(item) && isIssuedMapCard(item));
        if (!hasIssued) {
            return true;
        }

        showIssuedMapCardUpdateBlockedMessage();
        return false;
    }

    function cloneMapCardItemForUnclassifiedDisplay(item, placementTarget) {
        const clonedItem = cloneMapCardItem(item);
        if (isEmpty(clonedItem)) return clonedItem;

        [placementTarget?.horizontalColumn, placementTarget?.verticalColumn]
            .filter(column => !isEmpty(column))
            .forEach(column => {
                clonedItem[column] = "";
            });

        return clonedItem;
    }

    function mergeRegisteredProductValuesIntoMapCardItem(item, registerData) {
        const mergedItem = cloneMapCardItem(item);
        if (isEmpty(mergedItem)) return mergedItem;

        const product = registerData?.product || {};
        const assignValue = (keys, value) => {
            const text = String(value ?? "").trim();
            if (isEmpty(text)) return;
            keys.forEach((key) => {
                mergedItem[key] = text;
            });
        };

        assignValue(["PDTMD_BRDGP", "BRANDGROUP"], product.brandGroup);
        assignValue(["PDT_BRDCODE", "BRAND"], product.brandCode);
        assignValue(["PDT_YEAR", "SSD_YEAR"], product.year);
        assignValue(["PDT_SEASONCD", "SSD_SEASONCD"], product.seasonCode);
        assignValue(["PDT_HBSEASONCD"], product.salesSeasonCode);
        assignValue(["PDT_ITMCITEMCD", "PDT_AITEMCITEMCD", "PDT_ITMITEMCD"], product.itemCode);
        assignValue(["PDTMD_CATEGORY", "CATEGORY"], product.category);
        assignValue(["PDTMD_KIKAKUNO", "SSDX_KIKAKUNO", "KIKAKU_NO"], product.planningNo);
        assignValue(["SSD_SIIRECD", "PDT_TORCODE", "SIIRESAKI"], product.supplierCode);
        assignValue(["SSD_KAKOUSAKICD", "PDT_KAKOUSAKICD", "KAKOUSAKI"], product.processorCode);
        assignValue(["PDTMD_SHOPYMD", "SSDX_SHOPYMD"], product.shopDate);
        assignValue(["PDTMD_SHOPYMDM", "SSDX_SHOPYMDM"], product.rolloutMonth);
        assignValue(["PDTMD_SHOPYMDW", "SSDX_SHOPYMDW"], product.rolloutWeek);

        return mergedItem;
    }

    function getMapCardKey(item) {
        const candidates = [
            resolveMapCardValue(item, ["SSD_NO"]),
            resolveMapCardValue(item, ["PDT_OPPICD", "PDT_OppiCd"]),
            resolveMapCardValue(item, ["PDT_SYOHINCD", "PDT_SyohinCD", "PDT_HINBAN"]),
            resolveMapCardValue(item, ["SSDX_KIKAKUNO"]),
            resolveMapCardValue(item, ["SSDX_SHOPYMD"]),
            resolveMapCardValue(item, ["SSDM_COLORCD"]),
            resolveMapCardValue(item, ["SSDM_SIZECD"])
        ];

        const filtered = candidates
            .map(value => String(isEmpty(value) ? "" : value).trim())
            .filter(value => !isEmpty(value));
        return filtered.length === 0 ? "" : filtered.join("|");
    }

    function isSameMapCardRegistration(item, pdtOppiCd, ssdNo) {
        const targetOppiCd = String(pdtOppiCd || "").trim();
        const targetSsdNo = String(ssdNo || "").trim();
        if (isEmpty(targetOppiCd) || isEmpty(targetSsdNo)) return false;

        const itemOppiCd = String(resolveMapCardValue(
            item,
            ["PDT_OPPICD", "PDTMD_OPPICD", "SSD_OPPICD"]
        ) || "").trim();
        const itemSsdNo = String(resolveMapCardValue(
            item,
            ["SSD_NO", "SSDM_NO", "SSDX_NO"]
        ) || "").trim();

        return itemOppiCd === targetOppiCd && itemSsdNo === targetSsdNo;
    }

function getMapCardOppiCode(item) {
        const candidates = [
            resolveMapCardValue(item, ["PDT_OPPICD", "PDT_OppiCd"]),
            resolveMapCardValue(item, ["SSD_OPPICD", "SSD_OppiCd"]),
            resolveMapCardValue(item, ["PDTMD_OPPICD", "PDTMD_OppiCd"]),
            resolveMapCardValue(item, ["PDT_SYOHINCD", "PDT_SyohinCD", "PDT_HINBAN"])
        ];

        for (let i = 0; i < candidates.length; i++) {
            const value = String(candidates[i] ?? "").trim();
            if (isMeaningfulMapCardCodeValue(value)) {
                return value;
            }
        }

        return "";
}

function getMapCardHinbanMasterLaunchCode(item) {
        const candidates = [
            resolveMapCardValue(item, ["PDT_OPPICD", "PDT_OppiCd"]),
            resolveMapCardValue(item, ["SSD_OPPICD", "SSD_OppiCd"]),
            resolveMapCardValue(item, ["PDTMD_OPPICD", "PDTMD_OppiCd"])
        ];

        for (let i = 0; i < candidates.length; i++) {
            const value = String(candidates[i] ?? "").trim();
            if (isMeaningfulMapCardCodeValue(value)) {
                return value;
            }
        }

        return "";
}

function getMapCardBrandProductCode(item) {
    return resolveMapCardValue(item, ["PDT_SYOHINCD", "PDT_SyohinCD", "PDT_HINBAN"]);
}

function isMeaningfulMapCardCodeValue(value) {
    const text = String(value ?? "").trim();
    if (text === "") return false;
    return !/^0+$/.test(text);
}

    function isMapCardStopped(item) {
        const value = resolveMapCardValue(item, ["PDT_STOPFLG", "PDT_StopFlg", "SSD_DISFLG", "SSD_DisFlg"]);
        const normalized = String(isEmpty(value) ? "" : value).trim().toLowerCase();
        return normalized === "1" || normalized === "true" || normalized === "on";
    }

    function replaceMapCardByKey(cards, key, replacement) {
        const source = Array.isArray(cards) ? cards : [];
        if (isEmpty(key)) {
            return source.slice();
        }

        return source.map((item) => {
            const currentKey = getMapCardKey(item);
            if (!isEmpty(currentKey) && currentKey === key) {
                return replacement;
            }
            return item;
        });
    }

    function removeMapCardByKey(cards, key) {
        const source = Array.isArray(cards) ? cards : [];
        if (isEmpty(key)) {
            return source.slice();
        }

        return source.filter((item) => {
            if (isEmpty(item)) return false;
            const currentKey = getMapCardKey(item);
            return isEmpty(currentKey) || currentKey !== key;
        });
    }

    function appendUniqueMapCards(baseCards, extraCards) {
        const result = Array.isArray(baseCards) ? baseCards.slice() : [];
        const usedKeys = new Set();

        result.forEach((item) => {
            const key = getMapCardKey(item);
            if (!isEmpty(key)) usedKeys.add(key);
        });

        (Array.isArray(extraCards) ? extraCards : []).forEach((item) => {
            if (isEmpty(item)) return;
            const key = getMapCardKey(item);
            if (!isEmpty(key) && usedKeys.has(key)) return;
            if (!isEmpty(key)) usedKeys.add(key);
            result.push(item);
        });

        return result;
    }

    function applyDeletedMapCardFilter(cards) {
        const source = Array.isArray(cards) ? cards : [];
        return source.map((item) => {
            if (isEmpty(item)) return item;
            const key = getMapCardKey(item);
            if (!isEmpty(key) && deletedMapCardKeysRef.current.has(key)) {
                return null;
            }
            return item;
        });
    }

    function clearDeletedMapCardState() {
        deletedMapCardKeysRef.current.clear();
        deletedMapCardItemsRef.current.clear();
    }

    function syncMapBoardCards(nextCards) {
        const normalized = Array.isArray(nextCards) ? nextCards : [];
        mapSearchDataRef.current = normalized;
        setMapBoardCards(normalized);
    }

    function clearMapBoardCellWidthOverrides() {
        setMapBoardCellWidthOverrides({});
    }

    function buildMapBoardCellKey(verticalValue, horizontalValue) {
        const rowKey = String(verticalValue || "").trim();
        const columnKey = String(horizontalValue || "").trim();
        if (isEmpty(rowKey) || isEmpty(columnKey)) return "";
        return `${rowKey}||${columnKey}`;
    }

    function applyMovedMapCardsLocalState(items) {
        const sourceItems = Array.isArray(items) ? items : [];
        if (sourceItems.length === 0) {
            return;
        }

        const seenKeys = new Set();
        const acceptedItems = [];
        let nextBoardCards = Array.isArray(mapSearchDataRef.current) ? mapSearchDataRef.current.slice() : [];

        for (let i = 0; i < sourceItems.length; i++) {
            const item = sourceItems[i];
            if (isEmpty(item)) {
                continue;
            }

            const key = getMapCardKey(item);
            if (isEmpty(key) || seenKeys.has(key)) {
                continue;
            }

            seenKeys.add(key);
            acceptedItems.push(cloneMapCardItem(item));
            deletedMapCardKeysRef.current.add(key);
            deletedMapCardItemsRef.current.set(key, cloneMapCardItem(item));
            nextBoardCards = replaceMapCardByKey(nextBoardCards, key, null);
        }

        if (acceptedItems.length === 0) {
            return;
        }

        syncMapBoardCards(applyDeletedMapCardFilter(nextBoardCards));
        setUnclassifiedMapCards(prev => appendUniqueMapCards(prev, acceptedItems));
    }

    function updateMapCardLocalState(item, replacement, includeDeletedPopup = false) {
        const key = getMapCardKey(item);
        if (isEmpty(key)) return false;

        const nextBoardCards = replaceMapCardByKey(mapSearchDataRef.current, key, replacement);
        syncMapBoardCards(applyDeletedMapCardFilter(nextBoardCards));
        setUnclassifiedMapCards(prev => replaceMapCardByKey(prev, key, replacement));

        if (includeDeletedPopup) {
            deletedMapCardKeysRef.current.add(key);
            deletedMapCardItemsRef.current.set(key, cloneMapCardItem(replacement));
        }

        return true;
    }

    function collectUnclassifiedCards(serverCards) {
        const merged = appendUniqueMapCards(serverCards, Array.from(deletedMapCardItemsRef.current.values()));
        return merged;
    }

    function normalizeBoardAxisText(value) {
        if (isEmpty(value)) return "";
        return String(value)
            .trim()
            .replace(/[ 　]/g, "")
            .replace(/[：:]/g, "")
            .replace(/[×＊*\/／｜|,，、\(\)（）\[\]【】]/g, "")
            .toUpperCase();
    }

function matchBoardAxisColumn(candidate) {
        const text = normalizeBoardAxisText(candidate);
        if (isEmpty(text)) return null;

        // Column IDs must win over partial label matches such as SHOPYMD/SHOPYMDW.
        for (let i = 0; i < BOARD_AXIS_TOKEN_MAP.length; i++) {
            const entry = BOARD_AXIS_TOKEN_MAP[i];
            for (let j = 0; j < entry.tokens.length; j++) {
                const token = normalizeBoardAxisText(entry.tokens[j]);
                if (!isEmpty(token) && text === token) {
                    return {
                        column: entry.column,
                        label: entry.label || entry.tokens[j]
                    };
                }
            }
        }

        for (let i = 0; i < BOARD_AXIS_TOKEN_MAP.length; i++) {
            const entry = BOARD_AXIS_TOKEN_MAP[i];
            for (let j = 0; j < entry.tokens.length; j++) {
                const token = normalizeBoardAxisText(entry.tokens[j]);
                if (isEmpty(token)) continue;
                if (text === token || text.includes(token) || token.includes(text)) {
                    return {
                        column: entry.column,
                        label: entry.label || entry.tokens[j]
                    };
                }
            }
        }

        return null;
    }

    function normalizeTemplateLookupKey(key) {
        return String(key || "")
            .trim()
            .replace(/[\s_]/g, "")
            .toUpperCase();
    }

    function resolveTemplateValue(template, candidates) {
        if (isEmpty(template) || !Array.isArray(candidates) || candidates.length === 0) return "";

        const normalizedCandidates = candidates
            .map(candidate => normalizeTemplateLookupKey(candidate))
            .filter(candidate => !isEmpty(candidate));

        if (normalizedCandidates.length === 0) return "";

        const keys = Object.keys(template);
        for (let i = 0; i < keys.length; i++) {
            const currentKey = keys[i];
            const normalizedCurrentKey = normalizeTemplateLookupKey(currentKey);
            if (!normalizedCandidates.includes(normalizedCurrentKey)) continue;

            const value = template[currentKey];
            if (!isEmpty(value)) {
                return value;
            }
        }

        for (let i = 0; i < candidates.length; i++) {
            const candidate = candidates[i];
            if (Object.prototype.hasOwnProperty.call(template, candidate) && !isEmpty(template[candidate])) {
                return template[candidate];
            }
        }

        return "";
    }

    function resolveBoardAxisColumns(template) {
        const templateCode = resolveTemplateValue(template, ["M_CODE_CODE", "m_code_code", "mCodeCode"]);
        const x = resolveTemplateValue(template, ["M_CODE_NAME2", "m_code_name2", "mCodeName2"]);
        const y = resolveTemplateValue(template, ["M_CODE_NAME3", "m_code_name3", "mCodeName3"]);

        return {
            templateCode,
            x,
            y
        };
    }

    function resolveBoardAxisDescriptor(descriptor, fallback) {
        const fallbackAxis = {
            column: fallback.column,
            label: fallback.label,
            descriptor: isEmpty(descriptor) ? fallback.label : String(descriptor).trim()
        };

        const text = String(descriptor || "").trim();
        if (isEmpty(text)) {
            return fallbackAxis;
        }

        const candidates = [text].concat(text.split(/[×＊*\/／｜|,，、]/).map(token => token.trim()).filter(token => !isEmpty(token)));
        for (let i = 0; i < candidates.length; i++) {
            const matched = matchBoardAxisColumn(candidates[i]);
            if (!isEmpty(matched)) {
                return {
                    column: matched.column,
                    label: matched.label,
                    descriptor: text
                };
            }
        }

        return fallbackAxis;
    }

    function resolveBoardAxes(template) {
        const axisColumns = resolveBoardAxisColumns(template);
        const horizontal = resolveBoardAxisDescriptor(axisColumns.x, BOARD_AXIS_DEFAULTS.horizontal);
        const vertical = resolveBoardAxisDescriptor(axisColumns.y, BOARD_AXIS_DEFAULTS.vertical);
        return { horizontal, vertical };
    }

    function getBoardAxisValue(item, axis) {
        if (isEmpty(item) || isEmpty(axis)) return "";
        const column = String(axis.column || "").trim().toUpperCase();
        const keys = [column, column.toLowerCase(), column.replace(/_/g, ""), column.replace(/\./g, "")];
        return resolveMapCardValue(item, keys);
    }

    function formatBoardAxisValue(axis, value) {
        if (isEmpty(value)) return "";
        const column = String(axis?.column || "").toUpperCase();
        if (column === "SSDX_SHOPYMD" || column === "SSDNY_CENTER" || column.includes("DATE")) {
            return FormatDate(value);
        }

        return String(value).trim();
    }

    function buildMapCardPlacementTarget(item, boardAxes) {
        const horizontal = boardAxes?.horizontal || BOARD_AXIS_DEFAULTS.horizontal;
        const vertical = boardAxes?.vertical || BOARD_AXIS_DEFAULTS.vertical;
        return {
            horizontalColumn: horizontal.column,
            horizontalValue: getBoardAxisValue(item, horizontal),
            horizontalLabel: horizontal.label,
            verticalColumn: vertical.column,
            verticalValue: getBoardAxisValue(item, vertical),
            verticalLabel: vertical.label
        };
    }

    const boardAxes = resolveBoardAxes(mapBoardTemplate);

    function clearMapCardDragState() {
        dragMapCardRef.current = { item: null, source: "", key: "" };
    }

    function handleMapCardDragStart(item, source, event) {
        const key = getMapCardKey(item);
        if (isEmpty(key)) return;
        if (!ensureMapCardsUpdatable(item)) {
            if (!isEmpty(event)) {
                event.preventDefault();
                event.stopPropagation();
            }
            clearMapCardDragState();
            return;
        }

        dragMapCardRef.current = {
            item: cloneMapCardItem(item),
            source: String(source || ""),
            key: key
        };

        if (!isEmpty(event?.dataTransfer)) {
            event.dataTransfer.effectAllowed = "move";
            event.dataTransfer.setData("text/plain", key);
            event.dataTransfer.setData("application/json", JSON.stringify({
                key: key,
                source: String(source || "")
            }));
        }
    }

    function handleMapCardDragEnd() {
        clearMapCardDragState();
    }

    function executeMapCardPlacementDrop(targetAxis, dragged, key, dragSource, options = {}) {
        if (isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") {
            clearMapCardDragState();
            return;
        }
        if (!ensureMapCardsUpdatable(dragged)) {
            clearMapCardDragState();
            return;
        }

        const placement = targetAxis || {};
        const currentPlacement = buildMapCardPlacementTarget(dragged, boardAxes);
        const samePlacement =
            String(currentPlacement.horizontalValue || "").trim() === String(placement.horizontalValue || "").trim() &&
            String(currentPlacement.verticalValue || "").trim() === String(placement.verticalValue || "").trim();
        if (dragSource === "board" && samePlacement) {
            clearMapCardDragState();
            return;
        }

        const normalizedPlacementShopDate = normalizeShopDateValue(
            placement.shopDateValue ||
            placement.horizontalShopDate ||
            placement.verticalShopDate ||
            ""
        );
        const placementShopDate = normalizedPlacementShopDate === null ? "" : normalizedPlacementShopDate;

        const request = {
            hinban: String(getMapCardBrandProductCode(dragged) || "").trim(),
            ssdNo: String(resolveMapCardValue(dragged, ["SSD_NO"]) || "").trim(),
            templateCode: resolveBoardAxisColumns(mapBoardTemplateRef.current).templateCode,
            horizontalColumn: placement.horizontalColumn,
            horizontalValue: placement.horizontalValue,
            verticalColumn: placement.verticalColumn,
            verticalValue: placement.verticalValue,
            shopDateValue: placementShopDate,
            yearValue: String(DicVal(entrydataRef.current, "SSD_YEAR", "") || "").trim(),
            seasonCodeValue: String(
                DicVal(entrydataRef.current, "PDT_SEASONCD", "") ||
                DicVal(entrydataRef.current, "SSD_SEASONCD", "") ||
                ""
            ).trim(),
            clearPlacement: false,
            controller: controller,
            subkey: subkey
        };

        fnc.current.postaxios("tenkaimd/UpdateMapCardPlacement", request,
            {
                onSuccess: function (data) {
                    if (data.status === false) {
                        const message = !isEmpty(data?.message)
                            ? data.message
                            : !isEmpty(data?.errDescription)
                                ? data.errDescription
                                : "MAPカードの割付に失敗しました";
                        fnc.current.warnmsg(message);
                        fnc.current.wait(false);
                        clearMapCardDragState();
                        if (typeof options.afterError === "function") {
                            options.afterError(data, {
                                targetAxis: placement,
                                dragged: dragged,
                                key: key,
                                dragSource: dragSource
                            });
                        }
                        return;
                    }

                    const updatedItem = {
                        ...(isEmpty(dragged) ? {} : dragged),
                        [placement.horizontalColumn]: placement.horizontalValue,
                        [placement.verticalColumn]: placement.verticalValue,
                        ...(!isEmpty(placementShopDate) ? {
                            PDTMD_SHOPYMD: placementShopDate,
                            SSDX_SHOPYMD: placementShopDate
                        } : {})
                    };
                    deletedMapCardKeysRef.current.delete(key);
                    deletedMapCardItemsRef.current.delete(key);

                    const nextBoardCards = replaceMapCardByKey(mapSearchDataRef.current, key, updatedItem);
                    syncMapBoardCards(applyDeletedMapCardFilter(appendUniqueMapCards(nextBoardCards, [updatedItem])));
                    setUnclassifiedMapCards(prev => {
                        const next = removeMapCardByKey(prev, key);
                        if (dragSource === "popup" && next.length === 0) {
                            setMapCardPopupOpen(false);
                        }
                        return next;
                    });

                    const successMessage = !isEmpty(data?.note)
                        ? data.note
                        : "MAPカードをボードへ割り付けました";
                    if (!isEmpty(fnc.current) && typeof fnc.current.successmsg === "function") {
                        fnc.current.successmsg(successMessage);
                    }
                    fnc.current.wait(false);
                    clearMapCardDragState();
                    if (typeof options.afterSuccess === "function") {
                        options.afterSuccess(data, {
                            targetAxis: placement,
                            dragged: dragged,
                            key: key,
                            dragSource: dragSource,
                            updatedItem: updatedItem
                        });
                    }
                },
                onError: function (data) {
                    const message = !isEmpty(data?.message)
                        ? data.message
                        : !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : "MAPカードの割付に失敗しました";
                    fnc.current.warnmsg(message);
                    fnc.current.wait(false);
                    clearMapCardDragState();
                    if (typeof options.afterError === "function") {
                        options.afterError(data, {
                            targetAxis: placement,
                            dragged: dragged,
                            key: key,
                            dragSource: dragSource
                        });
                    }
                },
                errmsg: "MAPカードの割付に失敗しました"
            }
        );
    }

    function onEntryKeyDownCapture(e) {
        if (e.key !== "Enter" && e.keyCode !== 13) return;
        const targetId = e.target && e.target.id ? String(e.target.id) : "";
        if (isEmpty(targetId)) return;
        const sep = targetId.lastIndexOf("_");
        if (sep === -1) return;
        const columnid = targetId.substring(0, sep);
        if (!isTenkaiYearColumn(columnid)) return;
        scheduleTenkaiYearEnterValidation(columnid);
    }
    //主キー取得
    function primarykey() {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.primarykey)) return "";
        return columninfo.find(e => e.primarykey).columnid;
    }
    //項目名取得
    function nametocolumn(name) {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.columnid.indexOf(name) !== -1)) return "";
        return columninfo.find(e => e.columnid.indexOf(name) !== -1).columnid;
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //Entry画面定義を取得
        fnc.current.postaxios('common/GetEntryPanels', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = normalizeTenkaiMdSearchFields(data.colinfo.filter(e => e.logpid === G_id.BASE));
                    settextfieldsall(fields);
                    settextfields(normalizeTenkaiMdSearchFields(data.columns.filter(e => e.logpid === G_id.BASE)));
                    fnc.current.initMaster(data.master);

                    setprimarykeys(data.primarykeys);

                    let idx = 0;
                    let glist = [];
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panel.id, type: panel.type, index: idx });
                        idx++;
                    });
                    dispatch(setgridlist(glist));

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    clearform();
                    fnc.current.wait(false);
               }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);

    useEffect(() => {
        mapBoardTemplateRef.current = mapBoardTemplate;
    }, [mapBoardTemplate]);

    useEffect(() => {
        return () => {
            stopAddNewSubWindowWatcher();
        };
    }, []);

    useEffect(() => {
        return () => {
            closeRegisteredItemSearchState();
        };
    }, []);

    useEffect(() => {
        if (registeredItemSearchActiveRef.current && !searchlistOpen) {
            closeRegisteredItemSearchState();
        }
    }, [dispatch, searchlistOpen]);

    useEffect(() => {
        if (!registeredItemSearchActiveRef.current || !searchlistOpen) {
            return;
        }

        let disposed = false;
        const applyButtonLabel = () => {
            if (disposed) return;
            syncRegisteredItemSearchActionButton();
        };

        const observer = new MutationObserver(applyButtonLabel);
        const startTimer = setTimeout(applyButtonLabel, 0);

        if (typeof document !== "undefined" && document.body) {
            observer.observe(document.body, {
                childList: true,
                subtree: true,
                characterData: true
            });
        }

        return () => {
            disposed = true;
            clearTimeout(startTimer);
            observer.disconnect();
        };
    }, [searchlistOpen]);

    useEffect(() => {
        return () => {
            clearTenkaiYearEnterTimer();
        };
    }, []);

    useEffect(() => {
        if (formstatus === "COPY FORM") {
            columninfo.filter(e => e.copyclear).forEach(function (col) {
                entrydataRef.current[col.columnid] = "";
            });
            syncShopDateValidationState();
            rerender();
        }
    }, [formstatus]);

    //遷移state状態表示
    function callshow() {
        if (isEmpty(locationstate.current) || !("code" in locationstate.current)) {
            locationstate.current = null;   //最初の１度のみ
            return;
        }
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }
    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);

        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    call = false; break;
                }
            }
            //遷移表示
            if (call) callshow();
        }
    }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata",data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        if (isEmpty(code)) {
            setedittingcode("");
            clearform(true);
            dispatch(changestatus("NEW FORM"));
            return true;
        }
        clearform(false);
        //データ読み込み
        LoadData(code);
        return true;
    }

    //項目レイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try{
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            }
        } else {
            SetGridData(panel, AGRef.current.GetDatasource(GridApi(panel)));
        }
    }
    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }


    function EntryStatusAction(action) {
        const normalizedAction = String(action ?? "").trim().toLowerCase();

        if (normalizedAction === "new") {
            const executeNew = () => {
                clearform(true);
            };
            if (modify) {
                fnc.current.confmsg("編集内容は破棄されます。よろしいですか?", executeNew);
                return;
            }
            executeNew();
        }
    }

    function EntryStatusOptions(status) {
        if (status === "ENTRY FORM") {
            return ["NEW"];
        }
        return [];
    }

    function HandleEntryStatusAction(action) {
        EntryStatusAction(action);
    }

    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === "print_md_map_excel" || action === "print_md_map_pdf") {
            if (validateMapCardRequiredConditions()) {
                setReportOutputFormat(action === "print_md_map_pdf" ? "pdf" : "excel");
                setReportOptionDialogOpen(true);
            }
            return;
        }
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type)?true:e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid == "0") {    //基本情報
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            let logpid = col.logpid;
            Jump(logpid);
            let grid = GridApi({ id: logpid });
            if (!isEmpty(grid) && !isEmpty(AGRef.current)) {
                AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, grid);
            }
        }
    }
    function hasRequiredSearchConditionValue(field) {
        if (isEmpty(field)) return true;

        const rawValue = DicVal(entrydataRef.current, field.columnid, "");
        if (rawValue === 0 || rawValue === "0" || rawValue === false) {
            return true;
        }
        if (Array.isArray(rawValue)) {
            return rawValue.length !== 0;
        }
        if (isEmpty(rawValue)) {
            return false;
        }

        return String(rawValue).trim() !== "";
    }
    function focusSearchConditionField(field) {
        if (isEmpty(field)) return;

        Jump(G_id.BASE, field.type);
        setTimeout(() => {
            const targetId = `${field.columnid}_${field.type}`;
            const elem = document.getElementById(targetId);
            if (isEmpty(elem)) return;
            elem.focus();
            if (typeof elem.select === "function") {
                elem.select();
            }
        }, 0);
    }
    function validateMapCardRequiredConditions() {
        const requiredFields = isEmpty(textfields)
            ? []
            : textfields.filter(field => field.required);
        const missingFields = requiredFields.filter(field => !hasRequiredSearchConditionValue(field));

        if (missingFields.length === 0) {
            if (!isEmpty(fnc.current)) fnc.current.closewarnning();
            return true;
        }

        const warnings = missingFields.map(field => ({
            rowid: "0",
            col: field.columnid,
            message: "必須項目です"
        }));

        fnc.current.showwarndescription("必須検索条件を入力してください", warnings);
        focusSearchConditionField(missingFields[0]);
        return false;
    }

    function generateMdMapExcel(options) {
        if (reportOutputting || isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") return;

        const conditions = isEmpty(entrydataRef.current)
            ? {}
            : { ...entrydataRef.current };
        const reportOptions = options || {};
        const outputFormat = reportOutputFormat === "pdf" ? "pdf" : "excel";
        const outputLabel = outputFormat === "pdf" ? "PDF" : "Excel";

        setReportOutputting(true);
        fnc.current.wait(true);
        fnc.current.postaxios("TenkaiBoardMdMapReport/GenerateForTenkaiMd", {
            conditions: conditions,
            controller: controller,
            subkey: subkey,
            outputCost: reportOptions.outputCost !== false,
            outputComment: reportOptions.outputComment !== false,
            outputFormat: outputFormat
        }, {
            onSuccess: function (data) {
                const filename = data?.returnData?.filename;
                const downloadName = data?.returnData?.dnfile;
                setReportOutputting(false);
                setReportOptionDialogOpen(false);
                fnc.current.wait(false);

                if (isEmpty(filename) || isEmpty(downloadName)) {
                    fnc.current.warnmsg("帳票ファイルを取得できませんでした。");
                    return;
                }

                fnc.current.filedownload("excel/ExcelDownload", {
                    excelfile: filename,
                    dnfile: downloadName
                });
            },
            onError: function (data) {
                setReportOutputting(false);
                fnc.current.wait(false);
                const message = !isEmpty(data?.errDescription)
                    ? data.errDescription
                    : `MDマップ発行（${outputLabel}）に失敗しました。`;
                fnc.current.warnmsg(message);
            },
            errmsg: `MDマップ発行（${outputLabel}）に失敗しました。`
        });
    }

    function getMapData() {
        if (isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") return;

        const conditions = isEmpty(entrydataRef.current)
            ? {}
            : { ...entrydataRef.current };

        mapSearchDataRef.current = [];

        fnc.current.postaxios("tenkaimd/GetMapData", { conditions: conditions, controller: controller, subkey: subkey },
            {
                onSuccess: function (data) {
                    if (data.status === false) {
                        const message = !isEmpty(data?.message)
                            ? data.message
                            : !isEmpty(data?.errDescription)
                                ? data.errDescription
                                : "表示データの取得に失敗しました";
                        fnc.current.warnmsg(message);
                        fnc.current.wait(false);
                        return;
                    }

                    const cards = Array.isArray(data.data) ? data.data : [];
                    const template = data.template || null;
                    const axes = resolveBoardAxes(template);
                    const boardCards = [];

                    cards.forEach((item) => {
                        if (isEmpty(item)) return;
                        const horizontalValue = getBoardAxisValue(item, axes.horizontal);
                        const verticalValue = getBoardAxisValue(item, axes.vertical);
                        if (!isEmpty(horizontalValue) && !isEmpty(verticalValue)) {
                            boardCards.push(item);
                        }
                    });

                    setMapBoardTemplate(template);
                    clearDeletedMapCardState();
                    clearMapBoardCellWidthOverrides();
                    syncMapBoardCards(applyDeletedMapCardFilter(boardCards));
                    setUnclassifiedMapCards([]);
                    setMapCardPopupOpen(false);
                    setMapBoardVisible(true);
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    const message = !isEmpty(data?.message)
                        ? data.message
                        : !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : "表示データの取得に失敗しました";
                    fnc.current.warnmsg(message);
                    fnc.current.wait(false);
                },
                errmsg: "表示データの取得に失敗しました"
            }
        );
    }
    function getUnclassifiedMapCards() {
        if (isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") return;

        const conditions = isEmpty(entrydataRef.current)
            ? {}
            : { ...entrydataRef.current };

        fnc.current.postaxios("tenkaimd/GetUnclassifiedMapCards", { conditions: conditions, controller: controller, subkey: subkey },
            {
                onSuccess: function (data) {
                    if (data.status === false) {
                        const message = !isEmpty(data?.message)
                            ? data.message
                            : "MAPカード未分類データの取得に失敗しました";
                        fnc.current.warnmsg(message);
                        fnc.current.wait(false);
                        return;
                    }

                    setMapBoardTemplate(data.template || null);
                    clearDeletedMapCardState();
                    clearMapBoardCellWidthOverrides();
                    const cards = collectUnclassifiedCards(Array.isArray(data.data) ? data.data : []);
                    setUnclassifiedMapCards(cards);
                    setMapCardPopupOpen(true);
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    const message = !isEmpty(data?.message)
                        ? data.message
                        : !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : "MAPカード未分類データの取得に失敗しました";
                    fnc.current.warnmsg(message);
                    fnc.current.wait(false);
                },
                errmsg: "MAPカード未分類データの取得に失敗しました"
            }
        );
    }

    function getCreatedMapCards(pdtOppiCd, ssdNo) {
        if (isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") return;

        const conditions = isEmpty(entrydataRef.current)
            ? {}
            : { ...entrydataRef.current };
        fnc.current.wait(true);
        fnc.current.postaxios("tenkaimd/GetCreatedMapCards", {
            conditions: conditions,
            pdtOppiCd: pdtOppiCd,
            ssdNo: ssdNo,
            controller: controller,
            subkey: subkey
        }, {
            onSuccess: function (data) {
                if (data.status === false) {
                    const message = !isEmpty(data?.message)
                        ? data.message
                        : !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : "登録した品番のMAPカード取得に失敗しました";
                    fnc.current.warnmsg(message);
                    fnc.current.wait(false);
                    return;
                }

                const cards = Array.isArray(data.data) ? data.data.filter(item => !isEmpty(item)) : [];
                const template = data.template || mapBoardTemplateRef.current || null;
                const axes = resolveBoardAxes(template);
                const boardCards = [];
                const unclassifiedCards = [];

                cards.forEach((item) => {
                    const horizontalValue = getBoardAxisValue(item, axes.horizontal);
                    const verticalValue = getBoardAxisValue(item, axes.vertical);
                    if (!isEmpty(horizontalValue) && !isEmpty(verticalValue)) {
                        boardCards.push(item);
                    } else {
                        unclassifiedCards.push(item);
                    }
                });

                const createdKeys = new Set(cards.map(getMapCardKey).filter(key => !isEmpty(key)));
                const isRegisteredCard = (item) => {
                    if (isEmpty(item)) return false;
                    if (isSameMapCardRegistration(item, pdtOppiCd, ssdNo)) return true;
                    const key = getMapCardKey(item);
                    return !isEmpty(key) && createdKeys.has(key);
                };
                setMapBoardTemplate(template);
                clearMapBoardCellWidthOverrides();
                const currentBoardCards = (Array.isArray(mapSearchDataRef.current) ? mapSearchDataRef.current : [])
                    .filter(item => !isRegisteredCard(item));
                syncMapBoardCards(appendUniqueMapCards(currentBoardCards, boardCards));
                setMapBoardVisible(true);

                const currentUnclassifiedCards = Array.isArray(unclassifiedMapCards) ? unclassifiedMapCards : [];
                const remainingUnclassifiedCards = currentUnclassifiedCards
                    .filter(item => !isRegisteredCard(item));
                const nextUnclassifiedCards = appendUniqueMapCards(
                    remainingUnclassifiedCards,
                    unclassifiedCards
                );
                setUnclassifiedMapCards(nextUnclassifiedCards);
                if (unclassifiedCards.length > 0) {
                    setMapCardPopupOpen(true);
                } else if (nextUnclassifiedCards.length === 0) {
                    setMapCardPopupOpen(false);
                }

                fnc.current.wait(false);
            },
            onError: function (data) {
                const message = !isEmpty(data?.message)
                    ? data.message
                    : !isEmpty(data?.errDescription)
                        ? data.errDescription
                        : "登録した品番のMAPカード取得に失敗しました";
                fnc.current.warnmsg(message);
                fnc.current.wait(false);
            },
            errmsg: "登録した品番のMAPカード取得に失敗しました"
        });
    }

    function handleCreatedMapCardResult() {
        getMapData();
    }

    function stopAddNewSubWindowWatcher() {
        if (addNewSubWindowWatcherRef.current !== null) {
            clearInterval(addNewSubWindowWatcherRef.current);
            addNewSubWindowWatcherRef.current = null;
        }
    }

    function handleAddNewSubWindowClosed() {
        addNewSubWindowRef.current = null;
        handleCreatedMapCardResult();
    }

    function startAddNewSubWindowWatcher() {
        stopAddNewSubWindowWatcher();
        addNewSubWindowWatcherRef.current = setInterval(() => {
            let closed = false;
            try {
                const sub = addNewSubWindowRef.current;
                closed = isEmpty(sub) || sub.closed;
            } catch {
                closed = true;
            }
            if (!closed) return;

            stopAddNewSubWindowWatcher();
            handleAddNewSubWindowClosed();
        }, 500);
    }

    function openPlaceholderPopup(windowName, feature) {
        const sub = window.open("about:blank", windowName, feature);
        if (!sub) {
            addNewSubWindowRef.current = null;
            return null;
        }

        addNewSubWindowRef.current = sub;
        return sub;
    }

    function handleButtonAction(key) {
        if (key !== "show" && !mapBoardVisible) {
            return;
        }

        if (key === "show") {
            if (!validateMapCardRequiredConditions()) return;
            getMapData();
            return;
        }
        if (key === "registered-item") {
            openRegisteredItemSearchList();
            return;
        }
        if (key === "map-card") {
            if (!validateMapCardRequiredConditions()) return;
            getUnclassifiedMapCards();
            return;
        }
        if (key === "new-item") {
            openNewHinbanDialog();
            return;
        }
    }

    function handleMapCardOpenMaster(item) {
        const launchOppiCd = String(getMapCardHinbanMasterLaunchCode(item) || "").trim();
        if (isEmpty(launchOppiCd)) {
            if (typeof fnc.current.warnmsg === "function") {
                fnc.current.warnmsg("品番マスタを起動するための品番内部コードを取得できませんでした。");
            }
            return;
        }

        const brandHinban = String(getMapCardBrandProductCode(item) || "").trim();
        const startupData = buildHinbanMasterStartupData(item, launchOppiCd, brandHinban);
        const targetMenu = Array.isArray(menus)
            ? menus.find((menu) => String(DicVal(menu, "controller", "")).trim().toLowerCase() === "hinbanmaster")
            : null;
        const launchMenu = {
            ...(targetMenu || { controller: "hinbanmaster", ctrls: "" }),
            controller: "hinbanmaster"
        };
        const key = continueSession(user, Array.isArray(menus) ? menus : [], launchMenu, startupData);

        const targetTab = window.open("", "_blank");
        if (!targetTab) {
            if (typeof fnc.current.warnmsg === "function") {
                fnc.current.warnmsg("品番マスタを別タブで開けませんでした。ブラウザのポップアップ設定を確認してください。");
            }
            return;
        }

        try {
            const continueData = sessionStorage.getItem(key);
            if (continueData !== null) {
                targetTab.sessionStorage.setItem(key, continueData);
            }
            targetTab.location.href = `/hinbanmaster?key=${key}`;
        } catch {
            if (!targetTab.closed) {
                targetTab.close();
            }
            if (typeof fnc.current.warnmsg === "function") {
                fnc.current.warnmsg("品番マスタの起動に失敗しました。");
            }
        }
    }

    function handleMapCardOpenProductSub(item) {
        if (!ensureMapCardsUpdatable(item)) return;
        openEditHinbanDialog(item);
    }

    function handleMapCardPlacementDrop(targetAxis) {
        const dragged = dragMapCardRef.current && dragMapCardRef.current.item ? cloneMapCardItem(dragMapCardRef.current.item) : null;
        const key = dragMapCardRef.current && !isEmpty(dragMapCardRef.current.key)
            ? dragMapCardRef.current.key
            : getMapCardKey(dragged);
        const dragSource = String(dragMapCardRef.current?.source || "");
        if (isEmpty(dragged) || isEmpty(key)) {
            clearMapCardDragState();
            return;
        }
        if (!ensureMapCardsUpdatable(dragged)) {
            clearMapCardDragState();
            return;
        }

        const placement = targetAxis || {};
        if (isEmpty(placement.horizontalColumn) || isEmpty(placement.verticalColumn)) {
            clearMapCardDragState();
            return;
        }

        if (dragSource === "popup" && !isEmpty(fnc.current) && typeof fnc.current.confmsg === "function") {
            fnc.current.confmsg(MAP_CARD_PLACEMENT_CONFIRM_MESSAGE, () => {
                executeMapCardPlacementDrop(placement, dragged, key, dragSource);
            }, () => {
                clearMapCardDragState();
            });
            return;
        }

        if (dragSource === "board") {
            if (!isEmpty(fnc.current) && typeof fnc.current.confmsg === "function") {
                fnc.current.confmsg(MAP_CARD_MOVE_CONFIRM_MESSAGE, () => {
                    executeMapCardPlacementDrop(placement, dragged, key, dragSource);
                }, () => {
                    clearMapCardDragState();
                });
                return;
            }
        }

        executeMapCardPlacementDrop(placement, dragged, key, dragSource);
    }

    function handleMapCardStopToggle(item, stopOn) {
        if (isEmpty(item) || isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") return;
        if (!ensureMapCardsUpdatable(item)) return;

        const ssdNo = String(resolveMapCardValue(item, ["SSD_NO"]) || "").trim();
        if (isEmpty(ssdNo)) return;

        const productCode = String(getMapCardBrandProductCode(item) || "").trim();
        const request = {
            hinban: productCode,
            ssdNo: ssdNo,
            stopFlg: stopOn ? "1" : "0",
            controller: controller,
            subkey: subkey
        };

        fnc.current.postaxios("tenkaimd/UpdateMapCardStopFlag", request,
            {
                onSuccess: function (data) {
                    if (data.status === false) {
                        const message = !isEmpty(data?.message)
                            ? data.message
                            : !isEmpty(data?.errDescription)
                                ? data.errDescription
                                : stopOn
                                    ? "MAPカードの中止に失敗しました"
                                    : "MAPカードの復活に失敗しました";
                        fnc.current.warnmsg(message);
                        fnc.current.wait(false);
                        return;
                    }

                    const nextFlag = stopOn ? "1" : "0";
                    const key = getMapCardKey(item);
                    const issued = !isEmpty(resolveMapCardValue(item, ["SSD_SEIHINHACHUDENNO", "SSD_SeihinHachuDenno"]));
                    const processStopFlag = issued
                        ? resolveMapCardValue(item, ["SSD_DISFLG", "SSD_DisFlg"])
                        : nextFlag;
                    const updatedItem = {
                        ...(isEmpty(item) ? {} : item),
                        PDT_STOPFLG: nextFlag,
                        PDT_StopFlg: nextFlag,
                        SSD_DISFLG: processStopFlag,
                        SSD_DisFlg: processStopFlag
                    };

                    const nextBoardCards = replaceMapCardByKey(mapSearchDataRef.current, key, updatedItem);
                    syncMapBoardCards(applyDeletedMapCardFilter(nextBoardCards));
                    setUnclassifiedMapCards(prev => replaceMapCardByKey(prev, key, updatedItem));

                    if (!isEmpty(key) && deletedMapCardItemsRef.current.has(key)) {
                        deletedMapCardItemsRef.current.set(key, cloneMapCardItem(updatedItem));
                    }

                    if (stopOn && !isEmpty(data?.note)) {
                        fnc.current.successmsg(data.note);
                    }
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    const message = !isEmpty(data?.message)
                        ? data.message
                        : !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : stopOn
                                ? "MAPカードの中止に失敗しました"
                                : "MAPカードの復活に失敗しました";
                    fnc.current.warnmsg(message);
                    fnc.current.wait(false);
                },
                errmsg: stopOn ? "MAPカードの中止に失敗しました" : "MAPカードの復活に失敗しました"
            }
        );
    }

    function moveMapCardToUnclassified(items, options = {}) {
        const sourceItems = Array.isArray(items) ? items : [items];
        if (sourceItems.length === 0 || isEmpty(fnc.current) || typeof fnc.current.postaxios !== "function") {
            return Promise.resolve(false);
        }
        if (!ensureMapCardsUpdatable(sourceItems)) {
            return Promise.resolve(false);
        }

        const forceUnclassifiedDisplay = Boolean(options.forceUnclassifiedDisplay);
        const showSuccessMessage = options.showSuccessMessage !== false;
        const successMessage = !isEmpty(options.successMessage)
            ? options.successMessage
            : "MAPカードを未分類へ移動しました";
        const failureMessage = !isEmpty(options.failureMessage)
            ? options.failureMessage
            : "MAPカードの削除に失敗しました";
        const requestItems = [];
        const localItems = [];
        const seenKeys = new Set();

        for (let i = 0; i < sourceItems.length; i++) {
            const item = sourceItems[i];
            if (isEmpty(item)) {
                continue;
            }

            const key = getMapCardKey(item);
            if (isEmpty(key) || seenKeys.has(key)) {
                continue;
            }

            const placementTarget = buildMapCardPlacementTarget(item, boardAxes);
            const ssdNo = String(resolveMapCardValue(item, ["SSD_NO"]) || "").trim();
            const hinban = String(getMapCardBrandProductCode(item) || "").trim();
            if (isEmpty(ssdNo)) {
                continue;
            }

            seenKeys.add(key);
            localItems.push(forceUnclassifiedDisplay
                ? cloneMapCardItemForUnclassifiedDisplay(item, placementTarget)
                : cloneMapCardItem(item));
            requestItems.push({
                hinban: hinban,
                ssdNo: ssdNo,
                templateCode: resolveBoardAxisColumns(mapBoardTemplateRef.current).templateCode,
                horizontalColumn: placementTarget.horizontalColumn,
                horizontalValue: "",
                verticalColumn: placementTarget.verticalColumn,
                verticalValue: "",
                clearPlacement: true
            });
        }

        if (requestItems.length === 0) {
            return Promise.resolve(false);
        }

        return new Promise((resolve) => {
            fnc.current.postaxios("tenkaimd/UpdateMapCardPlacementBatch", {
                items: requestItems,
                controller: controller,
                subkey: subkey
            },
                {
                    onSuccess: function (data) {
                        if (data.status === false) {
                            const message = !isEmpty(data?.message)
                                ? data.message
                                : !isEmpty(data?.errDescription)
                                    ? data.errDescription
                                    : failureMessage;
                            fnc.current.warnmsg(message);
                            fnc.current.wait(false);
                            resolve(false);
                            return;
                        }

                        applyMovedMapCardsLocalState(localItems);

                        if (showSuccessMessage && !isEmpty(fnc.current) && typeof fnc.current.successmsg === "function") {
                            fnc.current.successmsg(!isEmpty(data?.note) ? data.note : successMessage);
                        }
                        fnc.current.wait(false);
                        resolve(data);
                    },
                    onError: function (data) {
                        const message = !isEmpty(data?.message)
                            ? data.message
                            : !isEmpty(data?.errDescription)
                                ? data.errDescription
                                : failureMessage;
                        fnc.current.warnmsg(message);
                        fnc.current.wait(false);
                        resolve(false);
                    },
                    errmsg: failureMessage
                }
            );
        });
    }

    function appendRegisteredItemsToUnclassifiedDisplay(items) {
        const sourceItems = Array.isArray(items) ? items : [items];
        if (sourceItems.length === 0) {
            return false;
        }
        if (!ensureMapCardsUpdatable(sourceItems)) {
            return false;
        }

        const acceptedItems = [];
        const seenKeys = new Set();

        for (let i = 0; i < sourceItems.length; i++) {
            const item = sourceItems[i];
            if (isEmpty(item)) {
                continue;
            }

            const key = getMapCardKey(item);
            if (isEmpty(key) || seenKeys.has(key)) {
                continue;
            }

            seenKeys.add(key);
            acceptedItems.push(cloneMapCardItemForUnclassifiedDisplay(item, buildMapCardPlacementTarget(item, boardAxes)));
        }

        if (acceptedItems.length === 0) {
            return false;
        }

        setUnclassifiedMapCards(prev => appendUniqueMapCards(prev, acceptedItems));
        return true;
    }

    function handleMapCardDelete(item) {
        return moveMapCardToUnclassified(item, {
            forceUnclassifiedDisplay: true,
            showSuccessMessage: true,
            successMessage: "MAPカードを未分類へ移動しました",
            failureMessage: "MAPカードの削除に失敗しました"
        }).then((result) => {
            if (result) {
                setMapCardPopupOpen(true);
            }

            return result;
        });
    }

    function closeMapCardPopup() {
        setMapCardPopupOpen(false);
        clearMapBoardCellWidthOverrides();
    }
    function Save(finallycallback, nocheck) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        storeRowData();
        SetPLData();    //PL行データをentrydataRefにセット
        var detail = {};
        for (let i = 0; i < gridlist.length; i++) {
            if (gridlist[i].id === G_id.PL) continue;
            detail[gridlist[i].type] = GridData(gridlist[i].id);
        }
        const paramdata = {
            "controller": formid,
            "data": entrydataRef.current,
            "detail": detail,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "code": edittingcode,
            "noconfirm": nocheck
        }
        storeRowData();
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "tenkaimd/UpdateEntry" : "tenkaimd/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            let pkey = primarykey();
                            if(pkey !== "")  entrydataRef.current[pkey] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("tenkaimd", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            //確認メッセージ
                            var msgs = ["内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください","　"];
                            for (let i = 0; i < data.warning.length; i++) {
                                msgs.push("・" + data.warning[i].message);
                            }
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                        } else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("tenkaimd/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
               },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    function LoadData(code) {
        if (isEmpty(code)) return;
        fnc.current.postaxios('tenkaimd/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                let memo = nametocolumn("_memo");
                                if (memo !== "") {
                                    if (memo in row) data.data[memo] = row[memo];
                                }
                                let sticky = nametocolumn("_sticky");
                                if (sticky !== "") {
                                    if (sticky in row) data.data[sticky] = row[sticky];
                                }
                                let mytags = nametocolumn("_mytags");
                                if (mytags !== "") {
                                    if (mytags in row) data.data[mytags] = row[mytags];
                                }
                            }
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = data.data;
                            syncShopDateValidationState(data.data);
                            syncTenkaiDisplayConditionNames(data.data);
                            //行データ
                            for (let i = 0; i < gridlist.length; i++) {
                                if (data.detail[gridlist[i].type] !== null) {
                                    SetGridData({ id: gridlist[i].id }, data.detail[gridlist[i].type]);
                                }
                            }

                            gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                                //PL行データ
                                SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                            });

                            fileRef.current = data.files;
                            imageRef.current = data.images;
                            dispatch(setimagelist(data.images));
                            rerender();
                        }
                        fnc.current.wait(false);
                   } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                   }
                },
                onError: function (data) {
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        )
    }
    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }
    //入力フィールドクリア
    function clearform(newform) {
        entrydataRef.current = initializedata(textfieldsall, staff);
        syncShopDateValidationState(entrydataRef.current);
        syncTenkaiDisplayConditionNames(entrydataRef.current);
        deletedMapCardKeysRef.current.clear();
        deletedMapCardItemsRef.current.clear();
        mapSearchDataRef.current = [];
        clearMapCardDragState();
        setMapBoardTemplate(null);
        setMapBoardVisible(false);
        setMapBoardCards([]);
        setUnclassifiedMapCards([]);
        clearMapBoardCellWidthOverrides();
        setMapCardPopupOpen(false);
        imageRef.current = null;
        fileRef.current = null;
        scrollRef.current = null;
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
            {
                onSuccess: function (data) {
                    for (let key in data.returnData) {
                        var col = textfieldsall.find(e => e.columnid === key);
                        if (!isEmpty(col)) col.initvalue = data.returnData[key];
                    }
                    entrydataRef.current = initializedata(textfieldsall, staff);
                    syncShopDateValidationState(entrydataRef.current);
                    syncTenkaiDisplayConditionNames(entrydataRef.current);
                    rerender();
                },
            }, true
            )
        }
    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({id:gridlist[i].id, type:gridlist[i].type}));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id, type: panel[p].type }));
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
               },
            }
        )
    }
    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(normalizeTenkaiMdSearchFields(data.columns.filter(e => e.logpid === G_id.BASE)));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //パネル別列情報取得
    function tabletype(id) {
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }

    //Basic Data Change
    function ValueChanged(id, value, edit) {
        if (isTenkaiYearColumn(id) && isTenkaiYearEnterPending(id)) {
            return;
        }
        value = normalizeYearPickerValue(id, value);
        if (isShopDateLimitColumn(id)) {
            if (edit === true) {
                scheduleShopDateValidation(id);
            }
            return;
        }
        syncTenkaiDisplayConditionName(id, value);
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            const baseid = "basepanel" + props.panel.type;
            const entryTextfields = Array.isArray(textfields)
                ? textfields.map(field => {
                    if (String(field?.columnid || "").toUpperCase() !== TENKAI_TEMPLATE_COLUMN) {
                        return field;
                    }

                    return {
                        ...field,
                        primary: false,
                        unchange: false,
                        locked: false
                    };
                })
                : textfields;
            return (
                <div id={baseid} className="tenkaimd-basepanel">
                    <EntryBase
                        fnc={entryFnc}
                        textfields={entryTextfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.grid) {
            return (
                <EntryGridAr
                    id={fnc.current.GridID(props.panel)}
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                    columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onFirstDataRendered={onFirstDataRendered}
                    formid={formid}
                    ValueChanged={() => storeRowData(props.panel)}
                    panel={props.panel}
                    EntrybodyRef={EntrybodyRef}
                />
            );
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    function EntryForm() {
        return (
            <Box
                ref={EntrybodyRef}
                style={{ padding: '8px 15px 40px', height: '100%', overflow: 'auto', backgroundColor: '#FFFFFF' }}
                onKeyDownCapture={onEntryKeyDownCapture}
            >
                <style>{`
                    .tenkaimd-basepanel .fieldlabel {
                        font-size: 10px;
                        padding-top: 8px;
                        line-height: 1;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                `}</style>
                <Paper
                    elevation={0}
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 165px)',
                        padding: '10px 12px 14px',
                        backgroundColor: '#ffffff',
                        border: '1px solid #d8d8d8',
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden'
                    }}
                >
                    <div style={{ marginBottom: 12, fontSize: 16, fontWeight: 700, color: '#333' }}>
                        展開ボード(MDマップ)
                    </div>
                    {panel.map((p,i) => {
                       const isBasePanel = p.id === '0';
                       return (
                            <Box
                               key={`${p.id}-${p.type}-${i}`}
                               display={panelhidden(p) ? "none" : "flex"}
                               justifyContent="space-around"
                               alignItems="center"
                               padding="5px"
                                >
                                <Paper
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        padding: isBasePanel ? 0 : 10,
                                        backgroundColor: isBasePanel ? 'transparent' : '#ffffff',
                                        border: isBasePanel ? 'none' : '1px solid #e0e0e0',
                                        boxShadow: 'none'
                                    }}
                               >
                                   <div style={{ position: 'relative', marginBottom: isBasePanel ? 0 : 5 }}>
                                       {p.name}
                                       {!isEmpty(p.name2) ? <> - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span></> : null}
                                       {isBasePanel || layoutlock ? null :
                                           <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                               <IconButton size="small" onClick={()=>SetBaseField(p.type)}  >
                                                   <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                               </IconButton>
                                           </div>
                                       }
                                       {isBasePanel || layoutlock || sectionclose ? null :
                                           <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                               <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                   <Icon style={{ fontSize: 16 }}>close</Icon>
                                               </IconButton>
                                           </div>
                                       }
                                    </div>
                                        <Contents panel={p}/>
                                    </Paper >
                               </Box>
                        );
                    })}
                    <Box style={{ width: '100%', flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginTop: 10, paddingLeft: 5 }}>
                            {TenkaiMdButtons.map((btn, index) => {
                                const disabled = btn.key !== "show" && !mapBoardVisible;
                                return (
                                    <Button
                                        key={btn.key}
                                        variant="contained"
                                        disableElevation
                                        size="small"
                                        disabled={disabled}
                                        onClick={() => handleButtonAction(btn.key)}
                                        style={{
                                            minWidth: index === 0 ? 54 : 0,
                                            marginRight: 8,
                                            marginBottom: 8,
                                            padding: '6px 14px',
                                            backgroundColor: disabled ? '#b7b7b7' : '#55b74f',
                                            color: disabled ? '#f2f2f2' : '#ffffff',
                                            fontWeight: 700,
                                            textTransform: 'none',
                                            borderRadius: 4
                                        }}
                                    >
                                        {btn.label}
                                    </Button>
                                );
                            })}
                        </div>
                        <Box style={{ marginTop: 12, flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                            <TenkaiMdBoardFrame
                                visible={mapBoardVisible}
                                items={mapBoardCards}
                                boardAxes={boardAxes}
                                cardLineOverrides={mapBoardCellWidthOverrides}
                                onOpenMaster={handleMapCardOpenMaster}
                                onOpenProductSub={handleMapCardOpenProductSub}
                                onToggleStop={handleMapCardStopToggle}
                                onDelete={handleMapCardDelete}
                                onCardDrop={handleMapCardPlacementDrop}
                                onCardDragStart={handleMapCardDragStart}
                                onCardDragEnd={handleMapCardDragEnd}
                            />
                        </Box>
                    </Box>
                </Paper>
            </Box>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            {/*primaryid削除　影響不明*/}
            <MasterBase
                ref={masterBaseRef}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                entryform={true}
                show={Show}
                primarykey={primarykeys}
                entrydataRef={entrydataRef}
                navmenu={navmenu}
                entryonly={true}
                entrystatusoptions={EntryStatusOptions}
                entrystatusaction={HandleEntryStatusAction}
           >
            <EntryForm/>
            </MasterBase>
            <AGFunc ref={AGRef} />
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.5,
                            m: 0,
                        }}
                        component="ul"
                        elevation={0}
                        style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                    >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                             />
                            </Paper>
                    </div>
                </div>
                : null}
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <TenkaiMdMapCardPopup
                open={mapCardPopupOpen}
                coveredByModal={hinbanDialogOpen}
                onClose={closeMapCardPopup}
                items={unclassifiedMapCards}
                title="MAPカード未分類"
                onOpenMaster={handleMapCardOpenMaster}
                onOpenProductSub={handleMapCardOpenProductSub}
                onDragStart={handleMapCardDragStart}
                onDragEnd={handleMapCardDragEnd}
            />
            <TenkaiMdHinbanDialog
                open={hinbanDialogOpen}
                initialValues={hinbanDialogInitialValues}
                mapCardItem={hinbanDialogMapCardItem}
                editMode={hinbanDialogEditMode}
                mdTounyuNo={edittingcode || ''}
                corpkey={corpkey}
                account={account}
                fnc={fnc}
                displayConditions={entrydataRef.current || {}}
                onClose={closeHinbanDialog}
                onRegisterSuccess={handleHinbanRegisterSuccess}
            />
            <TenkaiMdReportOptionDialog
                open={reportOptionDialogOpen}
                outputting={reportOutputting}
                outputFormat={reportOutputFormat}
                onClose={() => setReportOptionDialogOpen(false)}
                onOutput={generateMdMapExcel}
            />
        </div>
    );
};

